import type { TaskDefinitionFormSchema } from "api";
import { api } from "api";
import { type FC, useMemo } from "react";
import { useLoaderData, useNavigate } from "react-router-dom";

import { TaskDefinitionForm } from "./form";

const EditTaskDefinitionRoute: FC = () => {
  const navigate = useNavigate();
  const defaultValues = useLoaderData() as TaskDefinitionFormSchema;

  const onSubmit = useMemo(
    () => async (data: TaskDefinitionFormSchema) => {
      const resp = await api.updateTaskDefinition(data);
      await navigate(`/task-definitions/${resp.id}`);
    },
    [navigate],
  );

  return (
    <TaskDefinitionForm
      onSubmit={onSubmit}
      defaultValues={defaultValues}
      title="Edit Task Definition"
      submitButtonText="Update"
    />
  );
};

export default EditTaskDefinitionRoute;
